import {HttpRequest,HttpMethod} from "./http";

class LazadaProvider extends HttpRequest {
	
	// CRUD Platform Lazada
	Create(params) {
		return this.request(HttpMethod.Post,`/v1/platforms/lazadas`,params );
	}

}

export default LazadaProvider